import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-gradient-to-br dark:from-[#0c1427] dark:to-[#1a2332]" }
const _hoisted_2 = { class: "px-4 sm:px-6 lg:px-8 pt-6 pb-8" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6"
}
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6"
}
const _hoisted_5 = { class: "px-4 sm:px-6 lg:px-8 pb-8" }
const _hoisted_6 = { class: "bg-white dark:bg-white/10 backdrop-blur-[20px] shadow-[0_20px_40px_0_rgba(0,0,0,0.1)] rounded-3xl overflow-hidden border border-gray-100 dark:border-white/10" }
const _hoisted_7 = { class: "px-6 lg:px-8 py-6 border-b border-black/[0.06] dark:border-white/[0.06]" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" }
const _hoisted_9 = { class: "flex items-center gap-3 w-full sm:w-auto" }
const _hoisted_10 = { class: "relative w-full sm:w-auto" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "text-[15px] font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_13 = {
  key: 0,
  class: "ml-1 px-2 py-0.5 text-xs font-semibold bg-blue-500 text-white rounded-full"
}
const _hoisted_14 = { class: "flex gap-3 w-full sm:w-auto" }
const _hoisted_15 = { class: "overflow-x-auto" }
const _hoisted_16 = {
  key: 0,
  class: "flex justify-center items-center py-20"
}
const _hoisted_17 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_18 = {
  key: 2,
  class: "w-full"
}
const _hoisted_19 = { style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"} }
const _hoisted_20 = { class: "px-6 py-4 text-center" }
const _hoisted_21 = { class: "px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider text-white" }
const _hoisted_22 = { class: "px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider text-white" }
const _hoisted_23 = { class: "px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider text-white" }
const _hoisted_24 = { class: "px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider text-white" }
const _hoisted_25 = { class: "px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider text-white" }
const _hoisted_26 = { class: "px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider text-white" }
const _hoisted_27 = { class: "px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider text-white" }
const _hoisted_28 = { class: "divide-y divide-black/[0.06] dark:divide-white/[0.06]" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "px-6 py-4 text-center" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "px-6 py-4 text-center" }
const _hoisted_33 = { class: "flex items-center justify-center" }
const _hoisted_34 = { class: "w-10 h-10 rounded-full overflow-hidden ring-2 ring-white dark:ring-gray-800 shadow-md flex-shrink-0 mr-3" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "min-w-[120px]" }
const _hoisted_37 = { class: "text-sm font-semibold text-[#1d1d1f] dark:text-white truncate" }
const _hoisted_38 = { class: "text-xs text-[#8e8e93] dark:text-gray-400 truncate" }
const _hoisted_39 = { class: "px-6 py-4 text-center" }
const _hoisted_40 = { class: "text-sm text-[#3c3c43] dark:text-gray-300" }
const _hoisted_41 = { class: "px-6 py-4 text-center" }
const _hoisted_42 = { class: "px-6 py-4 text-center" }
const _hoisted_43 = { class: "material-symbols-outlined !text-[16px]" }
const _hoisted_44 = { class: "px-6 py-4 text-center" }
const _hoisted_45 = { class: "px-6 py-4 text-center" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "px-6 py-4 text-center" }
const _hoisted_49 = { class: "flex items-center justify-center gap-2" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "px-6 lg:px-8 py-4 border-t border-black/[0.06] dark:border-white/[0.06]" }
const _hoisted_53 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50 px-4"
}
const _hoisted_54 = { class: "relative transform transition-all duration-300 scale-100 bg-white dark:bg-gray-900/95 backdrop-blur-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] rounded-3xl p-8 w-full max-w-md" }
const _hoisted_55 = { class: "text-2xl font-semibold text-center mb-3 text-[#1d1d1f] dark:text-white" }
const _hoisted_56 = { class: "text-center mb-8 text-[#8e8e93] dark:text-gray-400" }
const _hoisted_57 = { class: "flex gap-3" }
const _hoisted_58 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50 px-4"
}
const _hoisted_59 = { class: "relative transform transition-all duration-300 scale-100 max-h-[90vh] overflow-y-auto bg-white dark:bg-gray-900/95 backdrop-blur-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] rounded-3xl p-8 w-full max-w-4xl" }
const _hoisted_60 = { class: "flex justify-between items-start mb-8 pb-6 border-b border-gray-100 dark:border-gray-800" }
const _hoisted_61 = { class: "flex items-center gap-4" }
const _hoisted_62 = { class: "w-16 h-16 rounded-2xl overflow-hidden ring-4 ring-white dark:ring-gray-800 shadow-lg" }
const _hoisted_63 = ["src", "alt"]
const _hoisted_64 = { class: "text-3xl font-bold text-[#1d1d1f] dark:text-white" }
const _hoisted_65 = { class: "text-lg text-[#8e8e93] dark:text-gray-400 mt-1" }
const _hoisted_66 = {
  key: 0,
  class: "space-y-8"
}
const _hoisted_67 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" }
const _hoisted_68 = { class: "p-4 rounded-2xl bg-[#f9fafb] dark:bg-white/5" }
const _hoisted_69 = { class: "font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_70 = { class: "p-4 rounded-2xl bg-[#f9fafb] dark:bg-white/5" }
const _hoisted_71 = { class: "font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_72 = { class: "p-4 rounded-2xl bg-[#f9fafb] dark:bg-white/5" }
const _hoisted_73 = { class: "font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_74 = { class: "p-4 rounded-2xl bg-[#f9fafb] dark:bg-white/5" }
const _hoisted_75 = { class: "p-4 rounded-2xl bg-[#f9fafb] dark:bg-white/5" }
const _hoisted_76 = { class: "font-medium text-[#1d1d1f] dark:text-white" }
const _hoisted_77 = {
  key: 0,
  class: "p-4 rounded-2xl bg-[#f9fafb] dark:bg-white/5"
}
const _hoisted_78 = { class: "whitespace-pre-line text-[#1d1d1f] dark:text-white" }
const _hoisted_79 = { class: "flex gap-3 mt-8" }
const _hoisted_80 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50 px-4"
}
const _hoisted_81 = { class: "relative transform transition-all duration-300 scale-100 max-h-[90vh] overflow-y-auto bg-white dark:bg-gray-900/95 backdrop-blur-[20px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] rounded-3xl p-8 w-full max-w-2xl" }
const _hoisted_82 = { class: "flex justify-between items-start mb-6 pb-6 border-b border-gray-100 dark:border-gray-800" }
const _hoisted_83 = { class: "flex items-center gap-4" }
const _hoisted_84 = { class: "text-2xl font-bold bg-gradient-to-r from-[#667eea] to-[#764ba2] bg-clip-text text-transparent" }
const _hoisted_85 = { class: "space-y-6" }
const _hoisted_86 = { class: "flex flex-wrap gap-2" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "flex flex-wrap gap-2" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "flex gap-3 mt-8" }
const _hoisted_91 = {
  key: 3,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_92 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl w-full max-w-2xl z-10 relative overflow-hidden border border-[#E5E7EB] dark:border-[#374151] max-h-[90vh] overflow-y-auto" }
const _hoisted_93 = { class: "bg-gradient-to-r from-[#007AFF] to-[#5856D6] p-6" }
const _hoisted_94 = { class: "flex justify-between items-center" }
const _hoisted_95 = {
  key: 0,
  class: "p-6"
}
const _hoisted_96 = { class: "flex flex-col sm:flex-row sm:items-center mb-8 p-6 bg-gradient-to-r from-[#F0F7FF] to-[#F0F4FF] dark:from-[#0c1427] dark:to-[#1a1a2e] rounded-2xl border border-[#007AFF]/20" }
const _hoisted_97 = { class: "relative mb-4 sm:mb-0 sm:mr-6" }
const _hoisted_98 = ["src", "alt"]
const _hoisted_99 = { class: "text-2xl font-bold text-[#1a1a1a] dark:text-white mb-1" }
const _hoisted_100 = { class: "text-[#007AFF] dark:text-[#40A9FF] font-medium" }
const _hoisted_101 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" }
const _hoisted_102 = { class: "p-4 bg-[#F0F7FF] dark:bg-[#0c1427] rounded-2xl border border-[#007AFF]/10" }
const _hoisted_103 = { class: "text-[#1a1a1a] dark:text-white font-medium break-words" }
const _hoisted_104 = { class: "p-4 bg-[#F0F9F5] dark:bg-[#0a1a0f] rounded-2xl border border-[#34C759]/10" }
const _hoisted_105 = { class: "text-[#1a1a1a] dark:text-white font-medium" }
const _hoisted_106 = { class: "p-4 bg-[#FFF7E6] dark:bg-[#1a1406] rounded-2xl border border-[#FF9500]/10" }
const _hoisted_107 = { class: "text-[#1a1a1a] dark:text-white font-medium" }
const _hoisted_108 = { class: "p-4 bg-[#F8F0FF] dark:bg-[#1a0d1a] rounded-2xl border border-[#5856D6]/10" }
const _hoisted_109 = { class: "text-[#1a1a1a] dark:text-white font-medium" }
const _hoisted_110 = { class: "p-4 bg-[#FFF0F5] dark:bg-[#1a0a12] rounded-2xl border border-[#FF2D92]/10" }
const _hoisted_111 = { class: "p-4 bg-[#F0F7FF] dark:bg-[#0c1427] rounded-2xl border border-[#007AFF]/10" }
const _hoisted_112 = { class: "text-[#1a1a1a] dark:text-white font-medium" }
const _hoisted_113 = {
  key: 0,
  class: "p-6 bg-gradient-to-r from-[#F8F9FA] to-[#E9ECEF] dark:from-[#0c0c0c] dark:to-[#1a1a1a] rounded-2xl border border-[#E5E7EB] dark:border-[#374151]"
}
const _hoisted_114 = { class: "text-[#1a1a1a] dark:text-white whitespace-pre-line break-words" }
const _hoisted_115 = { class: "border-t border-[#E5E7EB] dark:border-[#374151] p-6 bg-[#F8F9FA] dark:bg-[#0c0c0c]" }
const _hoisted_116 = { class: "flex justify-end gap-3" }
const _hoisted_117 = {
  key: 4,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_118 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl w-full max-w-4xl z-10 relative overflow-hidden border border-[#E5E7EB] dark:border-[#374151] max-h-[90vh] overflow-y-auto" }
const _hoisted_119 = { class: "bg-gradient-to-r from-[#34C759] to-[#00D4AA] p-6" }
const _hoisted_120 = { class: "flex justify-between items-center" }
const _hoisted_121 = {
  key: 0,
  class: "p-6"
}
const _hoisted_122 = { class: "p-6 bg-gradient-to-r from-[#F0F7FF] to-[#F0F4FF] dark:from-[#0c1427] dark:to-[#1a1a2e] rounded-2xl border border-[#007AFF]/20" }
const _hoisted_123 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_124 = ["value"]
const _hoisted_125 = ["value"]
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { class: "relative" }
const _hoisted_128 = {
  key: 0,
  class: "p-6 bg-gradient-to-r from-[#FFF7E6] to-[#FEF3C7] dark:from-[#1a1406] dark:to-[#2a2306] rounded-2xl border border-[#FF9500]/20"
}
const _hoisted_129 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_130 = { class: "block text-sm font-semibold text-[#1a1a1a] dark:text-white mb-2" }
const _hoisted_131 = ["type", "onUpdate:modelValue", "required"]
const _hoisted_132 = ["onUpdate:modelValue", "required"]
const _hoisted_133 = ["onUpdate:modelValue", "required"]
const _hoisted_134 = ["value"]
const _hoisted_135 = { class: "p-6 bg-gradient-to-r from-[#F8F0FF] to-[#F3E8FF] dark:from-[#1a0d1a] dark:to-[#2a1a2a] rounded-2xl border border-[#5856D6]/20" }
const _hoisted_136 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_137 = {
  key: 5,
  class: "fixed bottom-6 right-6 left-6 md:left-auto md:max-w-md z-50"
}
const _hoisted_138 = { class: "flex items-center justify-between" }
const _hoisted_139 = { class: "flex items-center" }
const _hoisted_140 = { class: "w-8 h-8 rounded-xl bg-white/20 flex items-center justify-center mr-3" }
const _hoisted_141 = { class: "font-medium" }
const _hoisted_142 = {
  key: 6,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_143 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-2xl w-full max-w-lg z-10 relative overflow-hidden border border-[#E5E7EB] dark:border-[#374151]" }
const _hoisted_144 = { class: "bg-gradient-to-r from-[#FF9500] to-[#FFB020] p-6" }
const _hoisted_145 = { class: "flex justify-between items-center" }
const _hoisted_146 = { class: "text-xl font-bold text-white" }
const _hoisted_147 = { class: "p-6" }
const _hoisted_148 = { class: "mb-6" }
const _hoisted_149 = { class: "text-[#1a1a1a] dark:text-white font-medium mb-1" }
const _hoisted_150 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_151 = {
  key: 1,
  class: "max-h-64 overflow-y-auto"
}
const _hoisted_152 = { class: "space-y-2" }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = { class: "flex items-center" }
const _hoisted_155 = { class: "w-12 h-12 rounded-2xl bg-gradient-to-br from-[#FF9500] to-[#FFB020] flex items-center justify-center text-white font-bold text-lg mr-4 group-hover:scale-105 transition-transform duration-200" }
const _hoisted_156 = { class: "font-semibold text-[#1a1a1a] dark:text-white" }
const _hoisted_157 = { class: "text-sm text-[#666666] dark:text-[#cccccc]" }
const _hoisted_158 = { class: "border-t border-[#E5E7EB] dark:border-[#374151] p-6 bg-[#F8F9FA] dark:bg-[#0c0c0c]" }
const _hoisted_159 = { class: "flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RevenueGrowthChart = _resolveComponent("RevenueGrowthChart")!
  const _component_LeadConversionChart = _resolveComponent("LeadConversionChart")!
  const _component_AnnualProfitChart = _resolveComponent("AnnualProfitChart")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.showCharts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "bg-white dark:bg-white/10 backdrop-blur-[10px] shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] rounded-2xl p-6 border border-gray-100 dark:border-white/10"
                }, _cache[39] || (_cache[39] = [
                  _createElementVNode("div", { class: "animate-pulse" }, [
                    _createElementVNode("div", { class: "h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-3" }),
                    _createElementVNode("div", { class: "h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-4" }),
                    _createElementVNode("div", { class: "h-16 bg-gray-200 dark:bg-gray-700 rounded" })
                  ], -1)
                ]))
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_RevenueGrowthChart, {
                "current-user-id": _ctx.currentUserId,
                "user-permissions": _ctx.userPermissions,
                "statistics-data": _ctx.statisticsData?.revenueGrowth,
                "is-loading": _ctx.chartsLoading
              }, null, 8, ["current-user-id", "user-permissions", "statistics-data", "is-loading"]),
              _createVNode(_component_LeadConversionChart, {
                "current-user-id": _ctx.currentUserId,
                "user-permissions": _ctx.userPermissions,
                "statistics-data": _ctx.statisticsData,
                "is-loading": _ctx.chartsLoading
              }, null, 8, ["current-user-id", "user-permissions", "statistics-data", "is-loading"]),
              _createVNode(_component_AnnualProfitChart, {
                "current-user-id": _ctx.currentUserId,
                "user-permissions": _ctx.userPermissions,
                "statistics-data": _ctx.statisticsData?.annualProfit,
                "is-loading": _ctx.chartsLoading
              }, null, 8, ["current-user-id", "user-permissions", "statistics-data", "is-loading"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-[#8e8e93]" }, "search")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: _ctx.directT('crm.leads.searchLead'),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
                    class: "bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 pl-11 pr-4 h-11 text-[15px] rounded-full w-full sm:w-[320px] text-black dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400 outline-none focus:ring-2 focus:ring-blue-500/30 transition-all shadow-md hover:shadow-lg focus:shadow-xl"
                  }, null, 40, _hoisted_11), [
                    [_vModelText, _ctx.searchQuery]
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterModal = true)),
                  class: _normalizeClass(["h-11 px-5 rounded-full bg-white dark:bg-white/10 border border-gray-200 dark:border-white/10 flex items-center gap-2 hover:shadow-lg transition-all shadow-md", { 'ring-2 ring-blue-500': _ctx.hasActiveFilters }])
                }, [
                  _cache[41] || (_cache[41] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-[#8e8e93] dark:text-gray-400" }, "filter_list", -1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.directT('crm.leads.filter')), 1),
                  (_ctx.activeFilterCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.activeFilterCount), 1))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.selectedLeads.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showBulkAssignModal && _ctx.showBulkAssignModal(...args))),
                      style: {"background":"#007AFF","color":"white","padding":"12px 20px","font-size":"15px","font-weight":"500"},
                      class: "rounded-full flex items-center gap-2 hover:opacity-90 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
                    }, [
                      _cache[42] || (_cache[42] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "person_add", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.directT('crm.leads.assignTo') || 'Assign To') + " (" + _toDisplayString(_ctx.selectedLeads.length) + ")", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args))),
                  style: {"background":"linear-gradient(135deg, #667eea 0%, #764ba2 100%)","color":"white","padding":"12px 20px","font-size":"15px","font-weight":"500"},
                  class: "rounded-full flex items-center gap-2 hover:opacity-90 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
                }, [
                  _cache[43] || (_cache[43] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, "add", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.directT('crm.leads.addNewLead')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[44] || (_cache[44] = [
                  _createElementVNode("div", { class: "relative" }, [
                    _createElementVNode("div", { class: "w-16 h-16 rounded-full border-4 border-gray-200 dark:border-gray-700" }),
                    _createElementVNode("div", { class: "w-16 h-16 rounded-full border-4 border-t-blue-500 animate-spin absolute top-0" })
                  ], -1)
                ])))
              : (_ctx.leads.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[45] || (_cache[45] = [
                    _createElementVNode("div", { class: "w-24 h-24 rounded-full bg-[#f2f2f7] dark:bg-white/5 flex items-center justify-center mb-4" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[48px] text-[#8e8e93] dark:text-gray-400" }, "inbox")
                    ], -1),
                    _createElementVNode("p", { class: "text-lg font-medium text-[#1d1d1f] dark:text-white" }, "No leads found", -1),
                    _createElementVNode("p", { class: "text-sm mt-1 text-[#8e8e93] dark:text-gray-400" }, "Start by adding your first lead", -1)
                  ])))
                : (_openBlock(), _createElementBlock("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_19, [
                        _createElementVNode("th", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectAll) = $event)),
                            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                            class: "w-5 h-5 rounded border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-blue-500 dark:bg-gray-700 dark:checked:bg-blue-600 dark:checked:border-blue-600"
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ])
                        ]),
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.directT('dashboard.customer')), 1),
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('common.phone')), 1),
                        _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.directT('common.nextCall')), 1),
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.directT('dashboard.crm.source')), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.directT('dashboard.status')), 1),
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.directT('todoList.assignedTo')), 1),
                        _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.directT('dashboard.crm.action')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedLeads, (lead) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: lead.id,
                          onClick: ($event: any) => (_ctx.handleRowClick(lead, $event)),
                          class: "hover:bg-gray-50/50 dark:hover:bg-white/5 transition-colors cursor-pointer"
                        }, [
                          _createElementVNode("td", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: lead.id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedLeads) = $event)),
                              class: "w-5 h-5 rounded border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-blue-500 dark:bg-gray-700 dark:checked:bg-blue-600 dark:checked:border-blue-600"
                            }, null, 8, _hoisted_31), [
                              [_vModelCheckbox, _ctx.selectedLeads]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("img", {
                                  src: _ctx.getLeadImageUrl(lead),
                                  alt: _ctx.getLeadName(lead),
                                  class: "w-full h-full object-cover"
                                }, null, 8, _hoisted_35)
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.getLeadName(lead)), 1),
                                _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.getCompanyName(lead)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_39, [
                            _createElementVNode("span", _hoisted_40, _toDisplayString(lead.phone || '—'), 1)
                          ]),
                          _createElementVNode("td", _hoisted_41, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-sm font-medium", _ctx.getNextCallClass(lead.next_call_date)])
                            }, _toDisplayString(_ctx.formatNextCallDate(lead.next_call_date)), 3)
                          ]),
                          _createElementVNode("td", _hoisted_42, [
                            _createElementVNode("span", {
                              class: "text-sm font-medium px-3 py-1 rounded-full inline-flex items-center gap-1",
                              style: _normalizeStyle({
                          backgroundColor: _ctx.isDarkMode() ? _ctx.getSourceColor(lead.source).darkBg : _ctx.getSourceColor(lead.source).bg,
                          color: _ctx.isDarkMode() ? _ctx.getSourceColor(lead.source).darkText : _ctx.getSourceColor(lead.source).text
                        })
                            }, [
                              _createElementVNode("i", _hoisted_43, _toDisplayString(_ctx.getSourceIcon(lead.source)), 1),
                              _createTextVNode(" " + _toDisplayString(lead.source), 1)
                            ], 4)
                          ]),
                          _createElementVNode("td", _hoisted_44, [
                            _createElementVNode("span", {
                              class: "px-3 py-1 rounded-full text-xs font-semibold inline-block",
                              style: _normalizeStyle(_ctx.getStatusClass(lead.status))
                            }, _toDisplayString(lead.status || 'New'), 5)
                          ]),
                          _createElementVNode("td", _hoisted_45, [
                            (lead.assigned_to)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.showAssignModal(lead)),
                                  class: "text-sm font-medium text-[#007AFF] hover:opacity-80 transition-opacity"
                                }, _toDisplayString(_ctx.getAssignedUserName(lead)), 9, _hoisted_46))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.showAssignModal(lead)),
                                  class: "text-sm inline-flex items-center justify-center gap-1 text-[#8e8e93] dark:text-gray-400 hover:opacity-80 transition-opacity"
                                }, _cache[46] || (_cache[46] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "person_add", -1),
                                  _createTextVNode(" Assign ")
                                ]), 8, _hoisted_47))
                          ]),
                          _createElementVNode("td", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.viewLead(lead)),
                                class: "w-8 h-8 rounded-full bg-[#34C759] text-white flex items-center justify-center transition-all hover:scale-110"
                              }, _cache[47] || (_cache[47] = [
                                _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "edit", -1)
                              ]), 8, _hoisted_50),
                              (_ctx.userPermissions.is_owner)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.deleteLead(lead)),
                                    class: "w-8 h-8 rounded-full bg-[#FF3B30] text-white flex items-center justify-center transition-all hover:scale-110"
                                  }, _cache[48] || (_cache[48] = [
                                    _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "delete", -1)
                                  ]), 8, _hoisted_51))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 8, _hoisted_29))
                      }), 128))
                    ])
                  ]))
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_Pagination, {
              items: _ctx.itemsPerPage,
              total: _ctx.totalFilteredLeads,
              currentPage: _ctx.currentPage,
              onPageChange: _ctx.handlePageChange
            }, null, 8, ["items", "total", "currentPage", "onPageChange"])
          ])
        ])
      ])
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_54, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "w-16 h-16 rounded-full bg-[#FFE5E5] dark:bg-red-500/20 mx-auto mb-6 flex items-center justify-center" }, [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[32px] text-[#FF3B30]" }, "delete")
            ], -1)),
            _createElementVNode("h3", _hoisted_55, _toDisplayString(_ctx.directT('crm.leads.deleteLeadQuestion')), 1),
            _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.directT('crm.leads.deleteLeadConfirmation')), 1),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#f2f2f7] dark:bg-white/10 text-[#1d1d1f] dark:text-white"
              }, _toDisplayString(_ctx.directT('crm.leads.cancel')), 1),
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#FF3B30] text-white"
              }, _toDisplayString(_ctx.directT('crm.leads.delete')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args)))
          }),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  (_ctx.leadToView)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getLeadImageUrl(_ctx.leadToView),
                        alt: _ctx.getLeadName(_ctx.leadToView),
                        class: "w-full h-full object-cover"
                      }, null, 8, _hoisted_63))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_64, _toDisplayString(_ctx.leadToView ? _ctx.getLeadName(_ctx.leadToView) : ''), 1),
                  _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.leadToView ? _ctx.getCompanyName(_ctx.leadToView) : ''), 1)
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                class: "w-10 h-10 rounded-full bg-gray-100 dark:bg-white/10 hover:bg-gray-200 dark:hover:bg-white/20 flex items-center justify-center transition-all hover:scale-110 hover:rotate-90"
              }, _cache[50] || (_cache[50] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-[#8e8e93] dark:text-gray-400" }, "close", -1)
              ]))
            ]),
            (_ctx.leadToView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[51] || (_cache[51] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wider mb-1 text-[#8e8e93] dark:text-gray-400" }, "Email", -1)),
                      _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.leadToView.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wider mb-1 text-[#8e8e93] dark:text-gray-400" }, "Phone", -1)),
                      _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.leadToView.phone || '—'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _cache[53] || (_cache[53] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wider mb-1 text-[#8e8e93] dark:text-gray-400" }, "Source", -1)),
                      _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.leadToView.source), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _cache[54] || (_cache[54] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wider mb-1 text-[#8e8e93] dark:text-gray-400" }, "Status", -1)),
                      _createElementVNode("span", {
                        class: "px-3 py-1 rounded-full text-xs font-semibold inline-block",
                        style: _normalizeStyle(_ctx.getStatusClass(_ctx.leadToView.status))
                      }, _toDisplayString(_ctx.leadToView.status || 'New'), 5)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _cache[55] || (_cache[55] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wider mb-1 text-[#8e8e93] dark:text-gray-400" }, "Created", -1)),
                      _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.formatDate(_ctx.leadToView.created_at)), 1)
                    ])
                  ]),
                  (_ctx.leadToView.notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                        _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wider mb-2 text-[#8e8e93] dark:text-gray-400" }, "Notes", -1)),
                        _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.leadToView.notes), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#f2f2f7] dark:bg-white/10 text-[#1d1d1f] dark:text-white"
              }, " Close "),
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.editLead(_ctx.leadToView))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#007AFF] text-white"
              }, _toDisplayString(_ctx.directT('crm.leads.editLead')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showFilterModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeFilterModal && _ctx.closeFilterModal(...args)))
          }),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "w-12 h-12 rounded-2xl bg-gradient-to-br from-[#667eea] to-[#764ba2] flex items-center justify-center shadow-lg" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[24px]" }, "filter_list")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_84, _toDisplayString(_ctx.directT('crm.leads.filter')), 1),
                  _cache[57] || (_cache[57] = _createElementVNode("p", { class: "text-sm text-[#8e8e93] dark:text-gray-400 mt-1" }, " Filter leads by various criteria ", -1))
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeFilterModal && _ctx.closeFilterModal(...args))),
                class: "w-10 h-10 rounded-full bg-gray-100 dark:bg-white/10 hover:bg-gray-200 dark:hover:bg-white/20 flex items-center justify-center transition-all hover:scale-110 hover:rotate-90"
              }, _cache[59] || (_cache[59] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-[#8e8e93] dark:text-gray-400" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", null, [
                _cache[60] || (_cache[60] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3 text-[#1d1d1f] dark:text-white" }, "Status", -1)),
                _createElementVNode("div", _hoisted_86, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: status.name,
                      onClick: ($event: any) => (_ctx.toggleFilter('status', status.name)),
                      class: _normalizeClass(["px-3 py-1 rounded-full text-sm font-medium transition-all", _ctx.filters.status.includes(status.name) ? 'bg-blue-500 text-white' : 'bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-white/20'])
                    }, _toDisplayString(status.name), 11, _hoisted_87))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[61] || (_cache[61] = _createElementVNode("h4", { class: "text-lg font-semibold mb-3 text-[#1d1d1f] dark:text-white" }, "Source", -1)),
                _createElementVNode("div", _hoisted_88, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: source.name,
                      onClick: ($event: any) => (_ctx.toggleFilter('source', source.name)),
                      class: _normalizeClass(["px-3 py-1 rounded-full text-sm font-medium transition-all", _ctx.filters.source.includes(source.name) ? 'bg-blue-500 text-white' : 'bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-white/20'])
                    }, _toDisplayString(source.name), 11, _hoisted_89))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("button", {
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.clearAllFilters && _ctx.clearAllFilters(...args))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#f2f2f7] dark:bg-white/10 text-[#1d1d1f] dark:text-white"
              }, " Clear All "),
              _createElementVNode("button", {
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                class: "flex-1 py-3 rounded-2xl font-medium transition-all bg-[#007AFF] text-white"
              }, " Apply Filters ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/50 backdrop-blur-sm",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args)))
          }),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _cache[63] || (_cache[63] = _createElementVNode("h3", { class: "text-xl font-bold text-white" }, "Lead Details", -1)),
                _createElementVNode("button", {
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                  class: "p-2 rounded-xl bg-white/20 hover:bg-white/30 text-white transition-all duration-200"
                }, _cache[62] || (_cache[62] = [
                  _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
                ]))
              ])
            ]),
            (_ctx.leadToView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("img", {
                        src: _ctx.getLeadImageUrl(_ctx.leadToView),
                        class: "w-20 h-20 rounded-2xl object-cover ring-4 ring-[#007AFF]/20",
                        alt: _ctx.leadToView.name
                      }, null, 8, _hoisted_98),
                      _cache[64] || (_cache[64] = _createElementVNode("div", { class: "absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-[#34C759] to-[#00D4AA] rounded-xl flex items-center justify-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-white !text-[16px]" }, "person")
                      ], -1))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", _hoisted_99, _toDisplayString(_ctx.leadToView.name), 1),
                      _createElementVNode("p", _hoisted_100, "ID: " + _toDisplayString(_ctx.getShortId(_ctx.leadToView.id)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "flex items-center mb-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#007AFF] mr-2 !text-[20px]" }, "email"),
                        _createElementVNode("p", { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }, "Email")
                      ], -1)),
                      _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.leadToView.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _cache[66] || (_cache[66] = _createElementVNode("div", { class: "flex items-center mb-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#34C759] mr-2 !text-[20px]" }, "phone"),
                        _createElementVNode("p", { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }, "Phone")
                      ], -1)),
                      _createElementVNode("p", _hoisted_105, _toDisplayString(_ctx.leadToView.phone || 'N/A'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _cache[67] || (_cache[67] = _createElementVNode("div", { class: "flex items-center mb-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#FF9500] mr-2 !text-[20px]" }, "business"),
                        _createElementVNode("p", { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }, "Company")
                      ], -1)),
                      _createElementVNode("p", _hoisted_107, _toDisplayString(_ctx.getCompanyName(_ctx.leadToView)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _cache[68] || (_cache[68] = _createElementVNode("div", { class: "flex items-center mb-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#5856D6] mr-2 !text-[20px]" }, "source"),
                        _createElementVNode("p", { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }, "Source")
                      ], -1)),
                      _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.leadToView.source), 1)
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _cache[69] || (_cache[69] = _createElementVNode("div", { class: "flex items-center mb-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#FF2D92] mr-2 !text-[20px]" }, "flag"),
                        _createElementVNode("p", { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }, "Status")
                      ], -1)),
                      _createElementVNode("span", {
                        class: "px-3 py-1 rounded-xl font-medium text-sm",
                        style: _normalizeStyle(_ctx.getStatusClass(_ctx.leadToView.status))
                      }, _toDisplayString(_ctx.leadToView.status || 'Close'), 5)
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      _cache[70] || (_cache[70] = _createElementVNode("div", { class: "flex items-center mb-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#007AFF] mr-2 !text-[20px]" }, "calendar_today"),
                        _createElementVNode("p", { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }, "Created Date")
                      ], -1)),
                      _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.formatDate(_ctx.leadToView.created_at)), 1)
                    ])
                  ]),
                  (_ctx.leadToView.notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                        _cache[71] || (_cache[71] = _createElementVNode("div", { class: "flex items-center mb-3" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined text-[#666666] dark:text-[#cccccc] mr-2 !text-[20px]" }, "note"),
                          _createElementVNode("p", { class: "text-sm font-medium text-[#666666] dark:text-[#cccccc]" }, "Notes")
                        ], -1)),
                        _createElementVNode("p", _hoisted_114, _toDisplayString(_ctx.leadToView.notes), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                  class: "py-3 px-6 bg-[#F0F7FF] dark:bg-[#0c1427] text-[#007AFF] dark:text-[#40A9FF] font-medium rounded-2xl transition-all duration-200 hover:bg-[#E6F3FF] dark:hover:bg-[#1a2642] border border-[#007AFF]/20"
                }, " Close "),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.editLead(_ctx.leadToView!))),
                  class: "py-3 px-6 bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#0056CC] hover:to-[#4338CA] shadow-lg"
                }, " Edit ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEditModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/50 backdrop-blur-sm",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args)))
          }),
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", _hoisted_120, [
                _cache[73] || (_cache[73] = _createElementVNode("h3", { class: "text-xl font-bold text-white" }, "Edit Lead", -1)),
                _createElementVNode("button", {
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args))),
                  class: "p-2 rounded-xl bg-white/20 hover:bg-white/30 text-white transition-all duration-200"
                }, _cache[72] || (_cache[72] = [
                  _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
                ]))
              ])
            ]),
            (_ctx.leadToEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                  _createElementVNode("form", {
                    onSubmit: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateLead && _ctx.updateLead(...args)), ["prevent"])),
                    class: "space-y-6"
                  }, [
                    _createElementVNode("div", _hoisted_122, [
                      _cache[83] || (_cache[83] = _createElementVNode("h4", { class: "text-lg font-bold text-[#1a1a1a] dark:text-white mb-4 flex items-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#007AFF] mr-2 !text-[24px]" }, "person"),
                        _createTextVNode(" Basic Information ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_123, [
                        _createElementVNode("div", null, [
                          _cache[74] || (_cache[74] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#1a1a1a] dark:text-white mb-2" }, "Name *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.leadToEdit.name) = $event)),
                            required: "",
                            class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all placeholder:text-[#999] focus:border-[#007AFF] focus:ring-4 focus:ring-[#007AFF]/10",
                            placeholder: "Enter lead name"
                          }, null, 512), [
                            [_vModelText, _ctx.leadToEdit.name]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[75] || (_cache[75] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#1a1a1a] dark:text-white mb-2" }, "Email *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.leadToEdit.email) = $event)),
                            required: "",
                            class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all placeholder:text-[#999] focus:border-[#007AFF] focus:ring-4 focus:ring-[#007AFF]/10",
                            placeholder: "Enter email address"
                          }, null, 512), [
                            [_vModelText, _ctx.leadToEdit.email]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[76] || (_cache[76] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#1a1a1a] dark:text-white mb-2" }, "Phone", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.leadToEdit.phone) = $event)),
                            class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all placeholder:text-[#999] focus:border-[#34C759] focus:ring-4 focus:ring-[#34C759]/10",
                            placeholder: "Enter phone number"
                          }, null, 512), [
                            [_vModelText, _ctx.leadToEdit.phone]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[78] || (_cache[78] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#1a1a1a] dark:text-white mb-2" }, "Status *", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.leadToEdit.status) = $event)),
                            required: "",
                            class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none cursor-pointer transition-all focus:border-[#FF9500] focus:ring-4 focus:ring-[#FF9500]/10"
                          }, [
                            _cache[77] || (_cache[77] = _createElementVNode("option", {
                              value: "",
                              disabled: ""
                            }, "Select Status", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: status.id,
                                value: status.name
                              }, _toDisplayString(status.name), 9, _hoisted_124))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.leadToEdit.status]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[80] || (_cache[80] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#1a1a1a] dark:text-white mb-2" }, "Source *", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.leadToEdit.source) = $event)),
                            required: "",
                            class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none cursor-pointer transition-all focus:border-[#5856D6] focus:ring-4 focus:ring-[#5856D6]/10"
                          }, [
                            _cache[79] || (_cache[79] = _createElementVNode("option", {
                              value: "",
                              disabled: ""
                            }, "Select Source", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: source.id,
                                value: source.name
                              }, _toDisplayString(source.name), 9, _hoisted_125))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.leadToEdit.source]
                          ])
                        ]),
                        (_ctx.leadToEdit.status && _ctx.leadToEdit.status.toLowerCase() === 'close')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                              _cache[82] || (_cache[82] = _createElementVNode("label", { class: "block text-sm font-semibold text-[#1a1a1a] dark:text-white mb-2" }, "Income", -1)),
                              _createElementVNode("div", _hoisted_127, [
                                _cache[81] || (_cache[81] = _createElementVNode("span", { class: "absolute left-4 top-1/2 -translate-y-1/2 text-[#666666] dark:text-[#cccccc] font-medium" }, "$", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.leadToEdit.dealamount) = $event)),
                                  placeholder: "0.00",
                                  min: "0",
                                  step: "0.01",
                                  class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] pl-8 pr-4 outline-none transition-all placeholder:text-[#999] focus:border-[#34C759] focus:ring-4 focus:ring-[#34C759]/10"
                                }, null, 512), [
                                  [_vModelText, _ctx.leadToEdit.dealamount]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.customFields.filter(f => f.required).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                          _cache[85] || (_cache[85] = _createElementVNode("h4", { class: "text-lg font-bold text-[#1a1a1a] dark:text-white mb-4 flex items-center" }, [
                            _createElementVNode("i", { class: "material-symbols-outlined text-[#FF9500] mr-2 !text-[24px]" }, "tune"),
                            _createTextVNode(" Custom Fields ")
                          ], -1)),
                          _createElementVNode("div", _hoisted_129, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields.filter(f => f.required), (field) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: field.key,
                                class: _normalizeClass(["mb-1", {'md:col-span-2': field.type === 'textarea'}])
                              }, [
                                _createElementVNode("label", _hoisted_130, _toDisplayString(field.label) + " " + _toDisplayString(field.required ? '*' : ''), 1),
                                (_ctx.getInputType(field.type) !== 'select' && field.type !== 'textarea')
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: _ctx.getInputType(field.type),
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                      required: field.required,
                                      class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none transition-all placeholder:text-[#999] focus:border-[#FF9500] focus:ring-4 focus:ring-[#FF9500]/10"
                                    }, null, 8, _hoisted_131)), [
                                      [_vModelDynamic, _ctx.customFieldValues[field.key]]
                                    ])
                                  : (field.type === 'textarea')
                                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                        key: 1,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                        required: field.required,
                                        rows: "3",
                                        class: "w-full rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 py-3 outline-none transition-all placeholder:text-[#999] focus:border-[#FF9500] focus:ring-4 focus:ring-[#FF9500]/10"
                                      }, null, 8, _hoisted_132)), [
                                        [_vModelText, _ctx.customFieldValues[field.key]]
                                      ])
                                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 2,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                        required: field.required,
                                        class: "w-full h-12 rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 outline-none cursor-pointer transition-all focus:border-[#FF9500] focus:ring-4 focus:ring-[#FF9500]/10"
                                      }, [
                                        _cache[84] || (_cache[84] = _createElementVNode("option", { value: "" }, "Select", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: option,
                                            value: option
                                          }, _toDisplayString(option), 9, _hoisted_134))
                                        }), 128))
                                      ], 8, _hoisted_133)), [
                                        [_vModelSelect, _ctx.customFieldValues[field.key]]
                                      ])
                              ], 2))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_135, [
                      _cache[86] || (_cache[86] = _createElementVNode("label", { class: "block text-lg font-bold text-[#1a1a1a] dark:text-white mb-4 flex items-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-[#5856D6] mr-2 !text-[24px]" }, "note"),
                        _createTextVNode(" Notes ")
                      ], -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.leadToEdit.notes) = $event)),
                        rows: "4",
                        placeholder: "Add any additional notes or comments...",
                        class: "w-full rounded-2xl text-[#1a1a1a] dark:text-white border-2 border-[#E5E7EB] dark:border-[#374151] bg-white dark:bg-[#0c0c0c] px-4 py-3 outline-none transition-all placeholder:text-[#999] focus:border-[#5856D6] focus:ring-4 focus:ring-[#5856D6]/10"
                      }, null, 512), [
                        [_vModelText, _ctx.leadToEdit.notes]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args))),
                        class: "py-3 px-6 bg-[#F0F7FF] dark:bg-[#0c1427] text-[#007AFF] dark:text-[#40A9FF] font-medium rounded-2xl transition-all duration-200 hover:bg-[#E6F3FF] dark:hover:bg-[#1a2642] border border-[#007AFF]/20"
                      }, " Cancel "),
                      _cache[87] || (_cache[87] = _createElementVNode("button", {
                        type: "submit",
                        class: "py-3 px-6 bg-gradient-to-r from-[#34C759] to-[#00D4AA] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#28A745] hover:to-[#00B894] shadow-lg"
                      }, " Save Changes ", -1))
                    ])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
          _createElementVNode("div", {
            class: _normalizeClass(["p-4 rounded-2xl shadow-2xl transform transition-all duration-300 border border-white/20 backdrop-blur-sm", { 
           'bg-gradient-to-r from-[#34C759] to-[#00D4AA] text-white': _ctx.toastType === 'success', 
           'bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] text-white': _ctx.toastType === 'error', 
           'bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white': _ctx.toastType === 'info' 
         }])
          }, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["material-symbols-outlined !text-[20px]", { 
                 'text-white': _ctx.toastType === 'success' || _ctx.toastType === 'error' || _ctx.toastType === 'info'
               }])
                  }, _toDisplayString(_ctx.toastType === 'success' ? 'check_circle' : _ctx.toastType === 'error' ? 'error' : 'info'), 3)
                ]),
                _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.toastMessage), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
                class: "ml-4 p-1 rounded-xl bg-white/20 hover:bg-white/30 transition-all duration-200"
              }, _cache[88] || (_cache[88] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-white" }, "close", -1)
              ]))
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showingAssignModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/50 backdrop-blur-sm",
            onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.closeAssignModal && _ctx.closeAssignModal(...args)))
          }),
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("div", _hoisted_145, [
                _createElementVNode("h3", _hoisted_146, _toDisplayString(_ctx.isBulkAssign ? `Assign ${_ctx.selectedLeads.length} Selected Leads` : 'Assign Lead'), 1),
                _createElementVNode("button", {
                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.closeAssignModal && _ctx.closeAssignModal(...args))),
                  class: "p-2 rounded-xl bg-white/20 hover:bg-white/30 text-white transition-all duration-200"
                }, _cache[89] || (_cache[89] = [
                  _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("p", _hoisted_149, _toDisplayString(_ctx.isBulkAssign ? 'Select a user to assign these leads to:' : `Assigning lead: ${_ctx.leadToAssign?.name || ''}`), 1),
                _cache[90] || (_cache[90] = _createElementVNode("p", { class: "text-[#666666] dark:text-[#cccccc] text-sm" }, " Choose from your organization's users below ", -1))
              ]),
              (_ctx.loadingUsers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_150, _cache[91] || (_cache[91] = [
                    _createElementVNode("div", { class: "inline-block" }, [
                      _createElementVNode("div", { class: "w-12 h-12 border-4 border-[#FF9500]/30 border-t-[#FF9500] rounded-full animate-spin" })
                    ], -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    _createElementVNode("div", _hoisted_152, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: user.user_id,
                          onClick: ($event: any) => (_ctx.isBulkAssign ? _ctx.assignSelectedLeads(user.user_id) : _ctx.assignLead(user.user_id)),
                          class: "p-4 rounded-2xl border border-[#E5E7EB] dark:border-[#374151] hover:border-[#FF9500] dark:hover:border-[#FF9500] bg-white dark:bg-[#0c0c0c] hover:bg-[#FFF7E6] dark:hover:bg-[#1a1406] cursor-pointer transition-all duration-200 group"
                        }, [
                          _createElementVNode("div", _hoisted_154, [
                            _createElementVNode("div", _hoisted_155, _toDisplayString(user.display_name ? user.display_name.substring(0, 1).toUpperCase() : user.email.substring(0, 1).toUpperCase()), 1),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_156, _toDisplayString(user.display_name || user.email), 1),
                              _createElementVNode("p", _hoisted_157, _toDisplayString(user.email), 1)
                            ])
                          ])
                        ], 8, _hoisted_153))
                      }), 128))
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.closeAssignModal && _ctx.closeAssignModal(...args))),
                  class: "py-3 px-6 bg-[#F0F7FF] dark:bg-[#0c1427] text-[#007AFF] dark:text-[#40A9FF] font-medium rounded-2xl transition-all duration-200 hover:bg-[#E6F3FF] dark:hover:bg-[#1a2642] border border-[#007AFF]/20"
                }, " Cancel "),
                (_ctx.currentUserId && !_ctx.isBulkAssign)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.assignLead(null))),
                      class: "py-3 px-6 bg-gradient-to-r from-[#666666] to-[#999999] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#555555] hover:to-[#888888] shadow-lg"
                    }, " Unassign "))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}